import { render, staticRenderFns } from "./OnChartMessage.vue?vue&type=template&id=19dd3c05&scoped=true&"
import script from "./OnChartMessage.vue?vue&type=script&lang=js&"
export * from "./OnChartMessage.vue?vue&type=script&lang=js&"
import style0 from "./OnChartMessage.vue?vue&type=style&index=0&id=19dd3c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd3c05",
  null
  
)

export default component.exports